import { create } from "zustand";
import { logger } from "../utils/logger";

interface ErrorStore {
  errorMessage: string | null;
  setErrorMessage: (message: string | null) => void;
}

export const useErrorStore = create<ErrorStore>((set) => ({
  errorMessage: null,
  setErrorMessage: (message) => {
    logger.error("[ErrorStore] Setting error message:", message);
    set({ errorMessage: message });
  },
}));
